// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__VJU2D","input":"ContactForm_input__EHzXZ"};